import { createFileRoute, redirect } from '@tanstack/react-router';
import { RoadmapPage } from '@/components/roadmap';

// Network-leader roadmap board. Gated on the server-evaluated
// `canViewRoadmap` capability from /me/context (Network leaders of an active
// Network + platform admins); everyone else lands back on /feed. The server
// enforces the same predicate on every roadmap route regardless.
export const Route = createFileRoute('/_authed/roadmap/')({
  beforeLoad: ({ context }) => {
    if (!context.capabilities.canViewRoadmap) throw redirect({ to: '/feed' });
  },
  component: RoadmapPage,
});
